module.exports = __webpack_public_path__ + "img/organisation_behandlung.2621683c.svg";